/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import React from 'react';

interface ProductHighlightsProps {
  heading: string;
  productHighlights?: { html: string };
}


const ProductHighlights = (props: ProductHighlightsProps) => {
  const { heading, productHighlights } = props;
  return <div className='product-highlights-container mt-5'>
    <h2 className='mb-4 strong'>{heading}</h2>
    <div
      className='highlight-list body'
      dangerouslySetInnerHTML={{ __html: productHighlights?.html ?? '' }}
    />
  </div>
}

export default ProductHighlights;
